import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_GET, API_GET_VARIATIONS } from '@/constants/apiConstants';

export interface GetVariationsResponse {
  status: 'SUCCESS' | 'ERROR';
  data?: any[];
  message?: string;
}

export const getVariations = async (
  jobUuid: string,
): Promise<GetVariationsResponse> => {
  const method: Method = API_METHOD_GET;
  const url = API_GET_VARIATIONS(jobUuid);

  try {
    const response = await apiCall({
      method,
      url,
    });
    return response; // Return the response data for further use
  } catch (error) {
    throw error; // Re-throw the error to be handled by the caller
  }
};
